import { createFileRoute } from '@tanstack/react-router';
import { ArticlePath, createGuideLink, RouteName } from '@mews-commander/enums';
import { ACTION_MENU_PORTAL_ID, BackendPage, getBackendPageUrl } from '@mews-commander/modules';
import { CreateOnboardingTasksButton } from '@mews-commander/modules/src/modules/enterprises';
import { DeferredPortal } from '@mews-commander/ui';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Enterprise/Detail/$enterpriseId/')({
    component: BackendPageComponent,
    staticData: {
        routeName: RouteName.EnterpriseDetail,
        owner: MewsTeam.MultiProperty,
        type: RouteType.Backend,
        guideLink: {
            enterprise: createGuideLink(ArticlePath.SetUpPropertyAccount),
            portfolio: createGuideLink(ArticlePath.OverviewPortfolioSettings),
        },
    },
});

function BackendPageComponent() {
    const { pathname, search, params } = Route.useMatch();

    return (
        <>
            <BackendPage url={getBackendPageUrl({ pathname, search })} withUnsavedChangesDialog />
            <DeferredPortal portalId={ACTION_MENU_PORTAL_ID}>
                <CreateOnboardingTasksButton enterpriseId={params.enterpriseId} />
            </DeferredPortal>
        </>
    );
}
